import React from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import './PaginationButtons.css';
import _ from 'lodash';

const PaginationButtons = ({ pagination, onPageChange }) => {
  const { page, limit, totalDocs } = pagination;
  const totalPages = Math.ceil(totalDocs / limit);

  if (totalPages <= 1) return null;

  const getPageRange = () => {
    const range = [];
    const delta = 2; // Number of pages to show around current page
    const left = page - delta;
    const right = page + delta + 1;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= left && i < right)) {
        range.push(i);
      } else if (i === left - 1 || i === right) {
        range.push('...');
      }
    }
    return _.uniq(range);
  };

  const pages = getPageRange();

  return (
    <div className="pagination-container border-top-blue mt-4">
      <div className="pagination-inner d-flex align-items-center justify-content-center">
        <button
          className="pagination-arrow-btn"
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
        >
          <BsChevronLeft />
        </button>

        <div className="pagination-numbers d-flex mx-3">
          {pages.map((p, index) => (
            p === '...' ? (
              <span key={`dots-${index}`} className="pagination-dots">...</span>
            ) : (
              <button
                key={p}
                className={`pagination-btn ${p === page ? 'active' : ''}`}
                onClick={() => onPageChange(p)}
              >
                {p}
              </button>
            )
          ))}
        </div>

        <button
          className="pagination-arrow-btn"
          disabled={page === totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          <BsChevronRight />
        </button>
      </div>
    </div>
  );
};

export default PaginationButtons;
